import React, { useRef } from 'react';

import isFunction from 'lodash/isFunction';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import Title from '@Components/Title';
import { useWithHover } from '@Hooks/withOnHoverStuff';
import { zoomSliderLevels } from '../ZoomConstants';

import './ZoomSlider.custom.scss';
import './ZoomSliderPure.custom.scss';

export default function ZoomSliderPure(props) {
  const { className, min, max, step, value, onChanged } = props;

  const [isHovered, onMouseEnterHandler, onMouseLeaveHandler] = useWithHover();

  const inputRef = useRef();

  const setZoomValue = (newValue) => {
    if (isFunction(onChanged)) {
      onChanged(newValue);
    }
  };
  const doDecrease = () => setZoomValue(Math.max(min, value - step));
  const doIncrease = () => setZoomValue(Math.min(max, value + step));

  const currentPercent = ((value - min) * 100) / (max - min);
  const { x, width } = (inputRef && inputRef.current && inputRef.current.getBoundingClientRect()) || {};
  const left = ((width - 14) * currentPercent) / 100 + x + 7 || 0;

  return (
    <div
      className={cn('zoom-slider-pure', className)}
      onMouseOver={onMouseEnterHandler}
      onMouseDown={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}>
      <Title style={{ left }} isOpen={isHovered}>
        {Math.round(value * 10) / 10}
      </Title>
      <Button
        onClick={() => doDecrease()}
        buttonConfig={{
          type: 'link',
          size: 'md',
          e2eName: 'zoom-out',
          ariaLabel: 'Zoom out',
        }}
        iconConfig={{ name: 'zoom-out' }}
      />
      <input
        ref={inputRef}
        type="range"
        step="any"
        className="input-range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => {
          e && e.target && e.target.value && setZoomValue(parseFloat(e.target.value));
        }}
        aria-label="Change zoom"
      />
      <Button
        onClick={() => doIncrease()}
        buttonConfig={{
          type: 'link',
          size: 'md',
          e2eName: 'zoom-in',
          ariaLabel: 'Zoom in',
        }}
        iconConfig={{ name: 'zoom' }}
      />
    </div>
  );
}

ZoomSliderPure.defaultProps = {
  min: zoomSliderLevels.min,
  max: zoomSliderLevels.max,
  step: zoomSliderLevels.step,
};

ZoomSliderPure.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  onChanged: PropTypes.func,
  className: PropTypes.string,
};
